(ns frontend.view.components.timeline.entry.person-create
  (:require
   [frontend.view.components.timeline.entry.declaration :as te]
   [frontend.view.components.timeline.entry.default-item :as default]
   [common.localization :as loc]
   [frontend.state.current-session :as session]))

(defn title-generator
  [entry]
  (let [op (-> entry
               :audit/op)
        person (->> entry
                    :audit/target
                    (get @session/entities))
        p-name (str (:person/first-name person) " " (:person/last-name person))]
    (loc/tr op [p-name])))

(defmethod te/timeline-entry-view :op.person/create
  [{entry :entry accounts :accounts}]
  [default/timeline-item-view entry title-generator default/body-generator
   default/timestamp-generator])
